import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import { MenuSearchBar, CategorySelector, Loader, MenuList, ProductPopup } from '@components'
import { useBlockNavigation, useCartRedux, useDashboardRedux, useUserRedux } from '@hooks'
import { DINING_METHOD } from '@common'

export default function TablePage() {
    const navigate = useNavigate()
    const { isLoading: isDashboardLoading, tables, fetchMenus, selectedProduct, setSelectedProduct } = useDashboardRedux()
    const { tableId, diningMethod } = useUserRedux()
    const { isUnsavedChanges } = useCartRedux()
    const menuListRef = useRef(null)
    const validTableIds = tables.map(t => t.id)

    useEffect(() => {
        fetchMenus()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        const isDineIn = diningMethod.value === DINING_METHOD.DineIn

        if (isDineIn && (!tableId || !validTableIds.includes(tableId.value))) {
            navigate('/', { replace: true })
        }
    }, [tableId, diningMethod, validTableIds, navigate])

    const NavigationBlocker = useBlockNavigation(isUnsavedChanges)

    return (
        <div>
            {isDashboardLoading && <Loader />}
            {NavigationBlocker}
            {/* <BannerCarousel items={BANNER_ITEMS} /> */}
            <div className="table-page-header">
                <h2>Menu</h2>
                {/* <MenuDisplayTypeSwitch /> */}
                <MenuSearchBar />
            </div>

            <CategorySelector menuListRef={menuListRef} />
            <div ref={menuListRef}>
                <MenuList />
            </div>
            <ProductPopup isOpen={!!selectedProduct} onClose={() => setSelectedProduct(null)} product={selectedProduct} />
        </div>
    )
}
